import {
  Crown,
  Castle,
  Crosshair,
  Swords,
  Smartphone,
  Zap,
  Shield,
  Landmark,
  ShieldHalf,
  Target,
  Gamepad2,
  Hammer,
  Rocket,
  Grid3X3,
  Layers,
  type LucideIcon,
} from 'lucide-react';

export interface GameConfig {
  code: string;
  name: string;
  shortName: string;
  icon: LucideIcon;
  comingSoon?: boolean;
}

export const GAMES: GameConfig[] = [
  { code: 'chess_com', name: 'Chess.com', shortName: 'Chess', icon: Crown },
  { code: 'lichess', name: 'Lichess', shortName: 'Lichess', icon: Castle },
  { code: 'valorant', name: 'Valorant', shortName: 'Valorant', icon: Crosshair },
  { code: 'lol', name: 'League of Legends', shortName: 'LoL', icon: Swords },
  { code: 'league_of_legends', name: 'League of Legends', shortName: 'LoL', icon: Swords },
  { code: 'wild_rift', name: 'Wild Rift', shortName: 'Wild Rift', icon: Smartphone },
  { code: 'brawl_stars', name: 'Brawl Stars', shortName: 'Brawl', icon: Zap },
  { code: 'clash_royale', name: 'Clash Royale', shortName: 'CR', icon: Shield },
  { code: 'clash_of_clans', name: 'Clash of Clans', shortName: 'CoC', icon: Landmark },
  { code: 'dota_2', name: 'Dota 2', shortName: 'Dota', icon: ShieldHalf },
  { code: 'pubg', name: 'PUBG', shortName: 'PUBG', icon: Target },
  { code: 'pubg_mobile', name: 'PUBG Mobile', shortName: 'PUBG', icon: Target, comingSoon: true },
  { code: 'faceit_cs2', name: 'FACEIT CS2', shortName: 'CS2', icon: Gamepad2 },
  { code: 'fortnite', name: 'Fortnite', shortName: 'Fortnite', icon: Hammer },
  { code: 'rocket_league', name: 'Rocket League', shortName: 'RL', icon: Rocket },
  { code: 'teamfight_tactics', name: 'Teamfight Tactics', shortName: 'TFT', icon: Grid3X3 },
  { code: 'legends_of_runeterra', name: 'Legends of Runeterra', shortName: 'LoR', icon: Layers },
  { code: 'fall_guys', name: 'Fall Guys', shortName: 'Fall Guys', icon: Zap },
];

const gameMap = new Map(GAMES.map((g) => [g.code, g]));

export function getGameConfig(code: string): GameConfig | undefined {
  return gameMap.get(code);
}

export function getGameIcon(code: string): LucideIcon {
  return gameMap.get(code)?.icon ?? Gamepad2;
}

export function getGameName(code: string): string {
  return gameMap.get(code)?.name ?? code.replace(/_/g, ' ');
}
